import { inject, Injectable } from '@angular/core';
import { NgxAimService } from '../ngx-aim.service';
import { Observable } from 'rxjs';
import {
  Category,
  ShortTermRentalDateTime,
  STRAmount,
  STRCalcItemAmountDto,
  STRCalcSubCatAmountDto,
  STRResult,
  SubCategory,
} from '../models';
import { HttpClient, HttpParams } from '@angular/common/http';
import { DayOfWeek } from '../enums';

@Injectable({
  providedIn: 'root'
})
export class ShortTermRentalService {
  ngxAimService = inject(NgxAimService);
  http = inject(HttpClient);

  private baseUrl = `${this.ngxAimService.getApiUrl()}/short-term-rental`;

  getRateForItem(itemPk: number): Observable<STRResult> {
    return this.http.get<STRResult>(`${this.baseUrl}/rates/${itemPk}`);
  }

  // TODO this isn't being used any where. Can we remove it?
  calcAmountForItem(dto: STRCalcItemAmountDto): Observable<STRAmount> {
    return this.http.post<STRAmount>(`${this.baseUrl}/calc-amount`, dto);
  }

  getCategories(): Observable<Category[]> {
    return this.http.get<Category[]>(`${this.ngxAimService.getApiUrl()}/category`);
  }

  getSubCategories(categorySlug: string): Observable<SubCategory[]> {
    return this.http.get<SubCategory[]>(`${this.ngxAimService.getApiUrl()}/category/${categorySlug}`);
  }

  getSubCategory(categorySlug: string, subCategorySlug: string): Observable<SubCategory> {
    return this.http.get<SubCategory>(`${this.ngxAimService.getApiUrl()}/category/${categorySlug}/${subCategorySlug}`);
  }

  getRateForSubCat(subCat: Partial<SubCategory>): Observable<STRResult> {
    return this.http.get<STRResult>(`${this.baseUrl}/rates-sub-cat/${subCat.categoryCategoryNumber}/${subCat.SubNumber}`);
  }

  calcAmountForSubCat(dto: STRCalcSubCatAmountDto): Observable<STRAmount> {
    return this.http.post<STRAmount>(`${this.baseUrl}/calc-amount-sub-cat`, dto);
  }

  getTimeSlots(dayOfWeek: DayOfWeek): Observable<ShortTermRentalDateTime[]> {
    return this.http.get<ShortTermRentalDateTime[]>(`${this.ngxAimService.getApiUrl()}/short-term-rental-date-time`, {
      params: new HttpParams()
        .set('dayOfWeek', dayOfWeek)
    });
  }

  getLodgingTimeSlots(dayOfWeek: DayOfWeek): Observable<ShortTermRentalDateTime[]> {
    return this.http.get<ShortTermRentalDateTime[]>(`${this.ngxAimService.getApiUrl()}/short-term-rental-date-time-lodging`, {
      params: new HttpParams()
        .set('dayOfWeek', dayOfWeek)
    });
  }

  getAllTimeSlots(): Observable<ShortTermRentalDateTime[]> {
    return this.http.get<ShortTermRentalDateTime[]>(`${this.ngxAimService.getApiUrl()}/short-term-rental-date-time/all`);
  }
}
